import {
  convertTimestampToBrazilianReadableText,
  getInitialsName,
  ModalBase,
} from '@repo/ui';
import { GetCompletedEvaluationDetailsUseCaseInterface } from 'domain/usecases';
import { Button, CardBody, Col, Row } from 'reactstrap';

interface ModalCompletedEvaluationDetailsProps {
  isOpen: boolean;
  loading: boolean;
  toggle: () => void;
  toggleModalDelete: () => void;
  clearSelectedEvaluationId: () => void;
  details: GetCompletedEvaluationDetailsUseCaseInterface.Result;
}

export const ModalCompletedEvaluationDetails = ({
  isOpen,
  toggle,
  loading,
  details,
  toggleModalDelete,
  clearSelectedEvaluationId,
}: ModalCompletedEvaluationDetailsProps) => {
  return (
    <ModalBase.Wrapper
      className="text-center"
      isOpen={isOpen}
      toggle={toggle}
      loading={loading}
    >
      <ModalBase.Header className="justify-content-start">
        <div className="d-flex align-items-center gap-3">
          {details?.studentPhoto ? (
            <img
              src={details.studentPhoto}
              alt={details.studentName}
              className="rounded-circle avatar-xl img-thumbnail object-fit-cover"
              style={{ width: '64px', height: '64px' }}
            />
          ) : (
            <div
              className="rounded-circle avatar-xl img-thumbnail bg-primary d-flex align-items-center justify-content-center"
              style={{ width: '64px', height: '64px' }}
            >
              <span className="fs-4 fw-bold text-white">
                {getInitialsName(details?.studentName || '')}
              </span>
            </div>
          )}

          <div className="text-start">
            <h5 className="mt-0 mb-1">{details?.studentName}</h5>

            {details?.criteriaName && (
              <small className="text-muted fs-14">{details.criteriaName}</small>
            )}

            {details?.surveyDate && (
              <div className="fs-14">
                <small>
                  {convertTimestampToBrazilianReadableText(details.surveyDate)}
                </small>
              </div>
            )}
          </div>
        </div>
      </ModalBase.Header>
      <ModalBase.Body>
        <Row className="g-3">
          {(details?.answers || []).map((awnser, index) => {
            return (
              <Col md={12} key={index}>
                <div className="card ribbon-box border right bg-light m-0">
                  <CardBody className="text-start">
                    <h5 className="fs-14">{awnser.criteriaQuestionTitle}</h5>
                    {awnser.question && (
                      <div className="ribbon-content text-muted mb-2">
                        {awnser.question}
                      </div>
                    )}
                    {awnser.answer && (
                      <p className="fw-medium mb-0">{awnser.answer}</p>
                    )}
                  </CardBody>
                </div>
              </Col>
            );
          })}

          <Col md={12}>
            <div className="card ribbon-box border right bg-light m-0">
              <CardBody className="text-start">
                <h5 className="fs-14">Comentários</h5>
                <div className="ribbon-content text-muted mb-2">
                  {details?.comments || 'Nenhum comentário'}
                </div>
              </CardBody>
            </div>
          </Col>

          {typeof details?.grade === 'number' && (
            <Col md={12}>
              <h5 className="fw-bold text-primary mb-0 mt-1">
                MÉDIA: {details.grade.toFixed(2).replace('.', ',')}
              </h5>
            </Col>
          )}
        </Row>
      </ModalBase.Body>
      <ModalBase.Footer className="justify-content-between">
        <Button
          type="button"
          className="btn btn-danger"
          onClick={toggleModalDelete}
        >
          Excluir
        </Button>
        <Button
          color="link"
          className="btn-link text-decoration-underline"
          onClick={() => {
            toggle();
            clearSelectedEvaluationId();
          }}
        >
          Fechar
        </Button>
      </ModalBase.Footer>
    </ModalBase.Wrapper>
  );
};
